import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
    CButton, CCard, CCardBody, CCardHeader
} from '@coreui/react';

import { apiClient } from 'services/Api';
import DataTableComponent from "components/DataTableComponent";
import AlertNotification from 'components/globals/AlertNotification';
import RecordDetailOffcanvas from "components/RecordDetailOffcanvas";

const SupplierList = () => {
    const navigate = useNavigate();
    const [suppliers, setSuppliers] = useState([]);
    const location = useLocation();
    const [previewSupplier, setPreviewSupplier] = useState(null);

    useEffect(() => {
        const fetchSuppliers = async () => {
            try {
                const response = await apiClient.get(`/suppliers/`);
                setSuppliers(response.data);
                setPreviewSupplier((current) => current
                    ? response.data.find((supplier) => supplier.id === current.id) || null
                    : null);
            } catch (error) {
                console.error('Error fetching suppliers:', error);
            }
        };

        fetchSuppliers();
    }, [location.pathname]);

    const handleDelete = async (supplierId) => {
        try {
            await apiClient.delete(`/suppliers/${supplierId}/`);
            setSuppliers((current) => current.filter((supplier) => supplier.id !== supplierId));
            setPreviewSupplier((current) => current?.id === supplierId ? null : current);
        } catch (error) {
            console.error('Error deleting supplier:', error);
        }
    };

    const columns = [
        { name: "Nome", selector: (row) => row.name, sortable: true, className: 'text-center' },
        { name: "Categoria", selector: (row) => row.category, sortable: true, className: 'text-center' },
        { name: "Qualificação", selector: (row) => row.situation, sortable: true, className: 'text-center' },
        { name: "Tipo de Serviço", selector: (row) => row.service_type, sortable: true, className: 'text-center' },
        { name: "Data de Início", selector: (row) => row.start_date, sortable: true, className: 'text-center' },
    ];

    return (
        <>
            <AlertNotification />
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Fornecedores</h3>
                    <Link to="/fornecedores/new">
                        <CButton color="info" className="text-white">Novo Fornecedor</CButton>
                    </Link>
                </CCardHeader>
                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={suppliers}
                        onRowClicked={setPreviewSupplier}
                    />
                </CCardBody>
            </CCard>
            <RecordDetailOffcanvas
                record={previewSupplier}
                onHide={() => setPreviewSupplier(null)}
                title="Fornecedor"
                subtitle={previewSupplier?.name}
                fields={previewSupplier ? [
                    { label: "Nome", value: previewSupplier.name },
                    { label: "Categoria", value: previewSupplier.category },
                    { label: "Qualificação", value: previewSupplier.situation },
                    { label: "Tipo de Serviço", value: previewSupplier.service_type },
                    { label: "Data de Início", value: previewSupplier.start_date },
                ] : []}
                headerActions={previewSupplier && <>
                    <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/fornecedores/${previewSupplier.id}`)}>
                        Ver/Editar
                    </CButton>
                    <CButton color="danger" size="sm" className="text-white" onClick={() => handleDelete(previewSupplier.id)}>
                        Eliminar
                    </CButton>
                </>}
            />
        </>
    );
};

export default SupplierList;
